module.exports = __webpack_public_path__ + "static/media/image_49.0f40e1bf.png";